import SweetScroll from 'sweet-scroll';
import UAParser from 'ua-parser-js';
import Vue from 'vue';
import MediaQuery from '../lib/MediaQuery';
import Tab from '../lib/Tab';
import v1FlightInformation from '../v1/v1FlightInformation.vue';
import sticky from './luxury-in-okinawa/module/sticky';

export default function luxuryInOkinawa() {
  const root = document.querySelector('.luxuryInOkinawa-root');
  if (!root) return;
  function v1FlightInfomation(elementID) {
    const v1FlightInfomationElm = document.getElementById(elementID);

    if (!v1FlightInfomationElm) return;

    const vm = new Vue({
      components: {
        v1FlightInformation,
      },
    });

    vm.$mount(`#${elementID}`);
  }
  v1FlightInfomation('flight-info-okinawa-main');
  v1FlightInfomation('flight-info-miyako');
  v1FlightInfomation('flight-info-ishigaki');

  const footLinks = document.querySelectorAll('.js-tabs-foot-link');

  let headerElement;
  const watchMQ = () => {
    MediaQuery.matches('lg', matches => {
      setTimeout(() => {
        if (matches) {
          headerElement = '#v1-header__head';
        } else {
          headerElement = '#v1-header__body';
        }
      }, 1000);
    });
  };
  watchMQ();

  const scroller = new SweetScroll({
    header: headerElement, // 固定ヘッダをCSSセレクタで指定
    duration: 1000, // アニメーション再生時間のミリ秒
    easing: 'easeOutQuint', // イージングのタイプ
    offset: 0, // スクロール位置のオフセット
    vertical: true, // 垂直方向のスクロールを許可する
    horizontal: false, // 水平方向のスクロールを許可する
    cancellable: true, // ホイールやタッチイベント発生時にスクロールを停止する
    updateURL: false, // スクロール完了後にURLを更新する
    preventDefault: true, // コンテナ要素のクリックイベントを防止する
    stopPropagation: true, // コンテナ要素のバブリングを防止する

    // スクロール先要素にフォーカスを変更する
    before() {
      const destination = document.getElementById('luxuryInOkinawa-itinerary__body');
      destination.setAttribute('tabindex', '-1');
      setTimeout(() => {
        destination.focus();
      }, 0);
    },
  });

  const scroller2 = new SweetScroll({
    trigger: '.luxuryInOkinawa-itineraryDetail__dayNavLink', // トリガーとなる要素をCSSセレクタで指定
    header: headerElement, // 固定ヘッダをCSSセレクタで指定
    duration: 1000, // アニメーション再生時間のミリ秒
    easing: 'easeOutQuint', // イージングのタイプ
    offset: 0, // スクロール位置のオフセット
    vertical: true, // 垂直方向のスクロールを許可する
    horizontal: false, // 水平方向のスクロールを許可する
    cancellable: true, // ホイールやタッチイベント発生時にスクロールを停止する
    updateURL: true, // スクロール完了後にURLを更新する
    preventDefault: true, // コンテナ要素のクリックイベントを防止する
    stopPropagation: true, // コンテナ要素のバブリングを防止する

    // スクロール先要素にフォーカスを変更する
    before(offset, $trigger, scrollElement) {
      const destination = document.getElementById(scrollElement.ctx.hash.replace('#', ''));
      destination.setAttribute('tabindex', '-1');
      setTimeout(() => {
        destination.focus();
      }, 0);
    },
  });

  const locationHash = window.location.hash;
  const hashExists = locationHash.length >= 1;

  if (hashExists) {
    window.addEventListener('DOMContentLoaded', () => {
      const scrollElement = document.getElementById(locationHash.substr(1));
      const needsInitialScroll = scrollElement != null;

      if (needsInitialScroll) {
        window.location.hash = '';
      }
    });

    window.addEventListener('load', () => {
      const scrollElement = document.getElementById(locationHash.substr(1));
      const needsInitialScroll = scrollElement != null;

      if (needsInitialScroll) {
        scroller2.to(locationHash, { updateURL: 'replace' });
      }
    });
  }

  const scrollTabTop = () => {
    scroller.toElement(document.getElementById('luxuryInOkinawa-itinerary__body'));
  };

  const tab = new Tab({
    afterClick(e) {
      const targetID = e.target.id;
      watchMQ();
      scrollTabTop();

      Array.from(footLinks).forEach(link => {
        const linkID = link.getAttribute('href').replace('#', '');

        if (targetID === linkID) {
          link.classList.add('-current');
          return;
        }
        link.classList.remove('-current');
      });
    },
  });

  /**
   * Recommended Itineraryのタブ
   */
  tab.init();

  /**
   * Recommended Itineraryの最後にあるタブ
   */
  const footTabs = document.querySelectorAll('.js-tabs-foot-link');
  const removeCurrentFootTabs = () => {
    Array.from(footTabs).forEach(footTab => {
      footTab.classList.remove('-current');
    });
  };
  Array.from(footTabs).forEach(footTab => {
    footTab.addEventListener('click', e => {
      const link = e.target.closest('.js-tabs-foot-link').getAttribute('href');
      const tabItem = document.querySelector(link);
      tabItem.click();
      scrollTabTop();

      removeCurrentFootTabs();
      footTab.classList.add('-current');

      e.preventDefault();
    });
  });

  const parser = new UAParser();
  const isIe = parser.getBrowser().name === 'IE';

  // sticky ... IEだけ作動させる
  if (isIe) {
    const fixMap = [].slice.call(
      document
        .querySelector('.luxuryInOkinawa-root')
        .querySelectorAll('.luxuryInOkinawa-itineraryDetail__day'),
    );
    Array.prototype.forEach.call(fixMap, map => {
      sticky(map, '.luxuryInOkinawa-itineraryDetail__dayMapWrap');
    });
  }
}
